import { useState, type ReactNode } from 'react';
import i18next, { type i18n as I18nInstance, type Resource } from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';

interface I18nProviderProps {
  resources: Resource;
  children: ReactNode;
}

export function I18nProvider({ resources, children }: I18nProviderProps) {
  const [instance] = useState<I18nInstance>(() => {
    const i = i18next.createInstance();
    i.use(initReactI18next).init({
      resources,
      lng: 'es-AR',
      fallbackLng: 'es-AR',
      interpolation: { escapeValue: false },
      returnNull: false,
    });
    return i;
  });

  return <I18nextProvider i18n={instance}>{children}</I18nextProvider>;
}
